import { forwardRef, useState } from 'react'
import type React from 'react'
import { type FieldVariant, inputVariants } from './fieldStyles'

/**
 * Styled input with focus effect. forwardRef is required for react-hook-form's
 * `register` — without it the field validates as empty.
 */
export const Input = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { variant?: FieldVariant }
>(({ variant = 'underline', style, onFocus, onBlur, ...rest }, ref) => {
  const [focused, setFocused] = useState(false)
  const styles = inputVariants[variant]
  return (
    <input
      ref={ref}
      {...rest}
      style={{
        ...styles.base,
        ...(focused ? styles.focus : {}),
        ...(rest.disabled ? { opacity: 0.45 } : {}),
        ...style,
      }}
      onFocus={(e) => {
        setFocused(true)
        onFocus?.(e)
      }}
      onBlur={(e) => {
        setFocused(false)
        onBlur?.(e)
      }}
    />
  )
})
Input.displayName = 'FormInput'
